import * as React from 'react';
import { SVGProps } from 'react';
const PropertiesDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={10}
    fill="none"
    {...props}
  >
    <path
      fill="#7F87B6"
      d="M7.97.5a1.487 1.487 0 0 0-1.06.435l-5.971 6a1.507 1.507 0 0 0-.325 1.641 1.507 1.507 0 0 0 .811.815 1.493 1.493 0 0 0 1.634-.326L7.971 4.1l4.926 4.77a1.493 1.493 0 0 0 1.685.381 1.493 1.493 0 0 0 .826-.866 1.508 1.508 0 0 0-.45-1.675L8.985.92A1.49 1.49 0 0 0 7.97.5Z"
      opacity={0.5}
    />
  </svg>
);
export default PropertiesDownIcon;
